import EvoButton from "../../components/form/fields/EvoButton";

export class Button {
    constructor(display, value = null) {
        this._component = EvoButton;
        this._display = display;
        this._value = value;
        this._next_step = null;
        this._other_datas_to_set = [];

        this._fields_to_send = [];
        this._extra_data_to_send = {};

        this._custom_class = null;
        this._icon = null;
    }

    icon(value){
        this._icon = value;
        return this;
    }

    customClass(value){
        this._custom_class = value;
        return this;
    }

    /**
     * @return Button
     * */
    nextStep(value) {
        this._next_step = value;
        return this;
    }

    /**
     * @return Button
     * */
    otherDatasToSet(path, fields) {
        _.forEach(fields, (fieldValue, fieldName) => {
            this._other_datas_to_set.push({
                path: path,
                name: fieldName,
                value: fieldValue
            })
        })
        return this;
    }

    /**
     * @param {array} value
     * @return Button
     * */
    addFieldsToSend(value) {
        this._fields_to_send = [...this._fields_to_send, ...value];
        return this;
    }

    /**
     * @return Button
     * */
    addExtraDataToSend(value) {
        this._extra_data_to_send = {...this._extra_data_to_send, ...value};
        return this;
    }

    shouldSendRequest() {
        return !!(_.size(this._fields_to_send) + _.size(this._extra_data_to_send));
    }

}
